/**
 * Lightweight shared form validators. Deliberately conservative — they reject
 * obvious junk (empty, malformed) without trying to be a full RFC parser, which
 * is the right trade-off for client-side UX hints. The server is the source of
 * truth; these just keep the user from submitting plainly bad input.
 */

/**
 * Pragmatic email check: a single "@", non-empty local + domain parts, a dot in
 * the domain, and no whitespace. Matches the common "looks like an email" bar
 * used across form UIs; the backend still validates authoritatively.
 */
export function isEmail(value: string): boolean {
  const v = value.trim();
  if (!v) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
